var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxes"},[_c('h3',[_c('Icon',{attrs:{"type":"md-bookmarks"}}),_vm._v("报警排名分析（前十）"),_vm._t("right")],2),_vm._v(" "),_c('Table',{attrs:{"data":_vm.tableData,"columns":_vm.columns},scopedSlots:_vm._u([{key:"tiredAlarm",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.tiredAlarm)+"次")])]}},{key:"telAlarm",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.telAlarm)+"次")])]}},{key:"distAlarm",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.distAlarm)+"次")])]}},{key:"collideAlarm",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.collideAlarm)+"次")])]}},{key:"deviateAlarm",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.deviateAlarm)+"次")])]}},{key:"rangeAlarm",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.rangeAlarm)+"次")])]}},{key:"smokeAlarm",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.smokeAlarm)+"次")])]}},{key:"alarmTotal",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.alarmTotal)+"次")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263df12b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataAnalyse/anaReports/baojingpaiming.vue
// module id = null
// module chunks = 